type SeatReservationAddon = {
  addon_type: string
  status: string
  flightId?: string
  travellerId?: string
  seatNumber?: string
}

export function isConfirmedSeatAddon(addon: SeatReservationAddon): boolean {
  return addon.addon_type === 'SEATS' && addon.status === 'confirmed'
}

/**
 * Journey seats can include assignments from unpaid `pending` reservation add-ons.
 * Those must not be treated as held/confirmed seats in My Escapes or seat-change checkout.
 * Seats with no matching SEATS add-on are left in place (included assignments).
 */
export function filterJourneySeatsToConfirmed<TSeat extends { travellerId: string, seatNumber: string }>(
  seats: Array<TSeat> | undefined,
  flightId: string | undefined,
  reservationAddons: Array<SeatReservationAddon> | undefined,
): Array<TSeat> | undefined {
  if (!seats?.length || !flightId || !reservationAddons?.length) {
    return seats
  }

  return seats.filter((seat) => {
    const matchingSeatAddons = reservationAddons.filter((addon) => (
      addon.addon_type === 'SEATS'
      && addon.flightId === flightId
      && addon.travellerId === seat.travellerId
      && (!addon.seatNumber || addon.seatNumber === seat.seatNumber)
    ))

    if (matchingSeatAddons.length === 0) {
      return true
    }

    return matchingSeatAddons.some(isConfirmedSeatAddon)
  })
}
